import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { spaceMapToPixel } from '../LayoutUtils'
import { ColumnStyle, GridLayoutType } from './types'
import getGridLayoutStyles from './config/styleConfig'

type PaddingType = {
    paddingRight?: string[]
    paddingLeft?: string[]
    paddingBottom?: string[]
}

const GridLayout: FunctionComponent<GridLayoutType> = ({
    columnType,
    firstColumn,
    secondColumn,
    thirdColumn,
    fourthColumn,
    spaceBetween,
    spaceX,
    spaceY,
    display,
    testID,
}): ReactElement => {
    const spaceBetweenToPixel = spaceMapToPixel.get(spaceBetween)
    const {
        flexWrap,
        firstColumnStyle,
        secondColumnStyle,
        thirdColumnStyle,
        fourthColumnStyle,
        hiddenColumnStyle,
    } = getGridLayoutStyles(spaceBetweenToPixel)[columnType]

    const getSpaceBetweenProps = (columnStyle: ColumnStyle): PaddingType | undefined => {
        if (spaceBetween) {
            return {
                paddingLeft: columnStyle.spaceBetweenX?.[spaceBetween]?.paddingLeft,
                paddingRight: columnStyle.spaceBetweenX?.[spaceBetween]?.paddingRight,
                paddingBottom: columnStyle.spaceBetweenY?.paddingBottom,
            }
        }
        return undefined
    }

    return (
        <Grid
            testID={testID}
            display={display}
            noExpand
            horizontal
            flexWrap={flexWrap || 'wrap'}
            paddingX={spaceMapToPixel.get(spaceX)}
            paddingY={spaceMapToPixel.get(spaceY)}
        >
            <Grid
                testID={`${testID}_column_1`}
                noExpand
                width={firstColumnStyle.width}
                minWidth={0}
                display={firstColumnStyle.display}
                {...getSpaceBetweenProps(firstColumnStyle)}
            >
                {firstColumn}
            </Grid>
            <Grid
                testID={`${testID}_column_2`}
                noExpand
                width={secondColumnStyle.width}
                minWidth={0}
                display={secondColumnStyle.display}
                {...getSpaceBetweenProps(secondColumnStyle)}
            >
                {secondColumn}
            </Grid>
            <Grid
                testID={`${testID}_column_3`}
                noExpand
                width={thirdColumnStyle.width}
                minWidth={0}
                display={thirdColumnStyle.display}
                {...getSpaceBetweenProps(thirdColumnStyle)}
            >
                {thirdColumn}
            </Grid>
            <Grid
                testID={`${testID}_column_4`}
                noExpand
                width={fourthColumnStyle.width}
                minWidth={0}
                display={fourthColumnStyle.display}
                {...getSpaceBetweenProps(fourthColumnStyle)}
            >
                {fourthColumn}
            </Grid>
            <Grid noExpand {...hiddenColumnStyle} />
        </Grid>
    )
}

export default GridLayout
